import {HttpClient, HttpHeaders, HttpParams, HttpResponse} from "@angular/common/http";

import {DatePipe} from "@angular/common";
import {DoubleCheckType} from "./feito-conferido/double-check-type";
import {Injectable} from '@angular/core';
import {Observable} from "rxjs";
import {catchError} from "rxjs/operators";
import {handleError} from "../shared/util/error-util";

@Injectable({
  providedIn: 'root'
})
export class FeitoConferidoService {

  private readonly url = '/v1/feito-conferidos';
  private readonly _httpHeaders = new HttpHeaders({'Content-Type': 'application/json'});

  constructor(
    private readonly datePipe: DatePipe,
    private readonly httpClient: HttpClient
  ) { }

  search(value: any): Observable<any> {
    const headers = this._httpHeaders;
    let params = this.createFormParam(value);
    params = params.set("size", value.itensPerPage);
    params = params.set("page", value.page);


    const options = {headers, params};
    return this.httpClient.get<any>(`${this.url}`, options);
  }

  getDoubleCheckType(): Observable<DoubleCheckType[]> {
    return this.httpClient.get<DoubleCheckType[]>(`${this.url}/tipos/`);
  }

  exportPdf(value: any): Observable<HttpResponse<Blob>> {
    const headers = this._httpHeaders;
    const params = this.createFormParam(value).set("size", '99999999');
    return this.httpClient.get(`${this.url}/export/pdf`,
      {headers, responseType: "blob", observe: "response", params}).pipe(catchError(handleError));
  }

  exportXlsx(value: any): Observable<HttpResponse<Blob>> {
    const headers = this._httpHeaders;
    const params = this.createFormParam(value).set("size", '99999999');
    return this.httpClient.get(`${this.url}/export/xlsx`,
      {headers, responseType: "blob", observe: "response", params}).pipe(catchError(handleError));
  }

  private createFormParam(value: any) {

    let params: HttpParams = new HttpParams();
    if (value.authDate) {
      params = params.set('authDate', this.datePipe.transform(value.authDate, 'yyyy-MM-dd'));
    }
    if (value.username && value.username !== '') {
      params = params.set('username', value.username);
    }
    if (value.action !== null && value.action !== '') {
      params = params.set('action', value.action);
    }
    if (value.entryType !== null && value.entryType !== '') {
      params = params.set('entryType', value.entryType);
    }
    if (value.description !== null && value.description !== '') {
      params = params.set('description', value.description);
    }

    params = params.set("sort", "timestamp,DESC");
    params = params.append("sort", "username,ASC");
    params = params.append("sort", "action,ASC");
    params = params.append("sort", "entryType,ASC");
    params = params.append("sort", "description,ASC");
    return params;
  }

  reject(id: number) {
    const headers = this._httpHeaders;
    const params: HttpParams = new HttpParams();
    const options = {headers, params};
    return this.httpClient.post<any>(`${this.url}/reject`, id, options);
  }

  authorize(id: number) {
    const headers = this._httpHeaders;
    const params: HttpParams = new HttpParams();
    const options = {headers, params};
    return this.httpClient.post<any>(`${this.url}/authorize`, id, options);
  }

}
